import { paramsParse, uuid } from 'analytics-utils';
import { cookies } from './jucyCookies';

const isServer = typeof window === 'undefined';

const JUCY_SESSION_COOKIE_NAME = 'sessionId';
const JUCY_SESSION_URL_PARAM = 'sessionId';

const sessionIdFromUrlParams = () => {
    if (isServer) {
        return;
    }
    const params = paramsParse(window.location.search) as Record<string, string>;

    return typeof params[JUCY_SESSION_URL_PARAM] === 'string' ? params[JUCY_SESSION_URL_PARAM] : undefined;
};

const sessionIdFromCookie = () => {
    const cookieSessionId = cookies.get(JUCY_SESSION_COOKIE_NAME);
    return typeof cookieSessionId === 'string' ? cookieSessionId : undefined;
};
let sessionId: string | undefined;
if (!isServer) {
    sessionId = sessionIdFromUrlParams() || sessionIdFromCookie() || uuid();
    cookies.set(JUCY_SESSION_COOKIE_NAME, sessionId, { expires: undefined });
}

export const analytics = {
    plugins: {
        session: {
            decorateLink: (url: URL) => {
                const result = new URL(url);
                if (sessionId) {
                    result.searchParams.set(JUCY_SESSION_URL_PARAM, sessionId);
                }
                return result;
            },
        },
    },
};
